import { useNavigate } from 'react-router-dom'
import { useCart } from '../contexts/CartContext'

interface CartDrawerProps {
  open: boolean
  onClose: () => void
}

export function CartDrawer({ open, onClose }: CartDrawerProps) {
  const { cart, removeItem, updateQty, subtotal, clearCart } = useCart()
  const navigate = useNavigate()

  function handleCheckout() {
    onClose()
    navigate('/checkout')
  }

  function handleClear() {
    if (window.confirm('¿Vaciar el carrito?')) {
      clearCart()
      onClose()
    }
  }

  if (!open) return null

  return (
    <>
      <div className="drawer-overlay" onClick={onClose} />
      <div className="cart-drawer">
        <div className="cart-drawer-header">
          <h2>Carrito</h2>
          {cart && (
            <span className="cart-drawer-store">
              {cart.storeName}
            </span>
          )}
          <button type="button" className="btn btn-ghost btn-sm cart-drawer-close" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="cart-drawer-body">
          {!cart || cart.items.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">🛒</div>
              <p>Tu carrito está vacío</p>
            </div>
          ) : (
            <ul className="cart-item-list">
              {cart.items.map(item => (
                <li key={item.productId} className="cart-item">
                  <div className="cart-item-info">
                    <span className="cart-item-name">{item.name}</span>
                    {item.sku && <span className="cart-item-sku">SKU: {item.sku}</span>}
                    <span className="cart-item-unit">Q {item.price.toFixed(2)} c/u</span>
                  </div>
                  <div className="cart-item-controls">
                    <button
                      type="button"
                      className="qty-btn"
                      onClick={() => updateQty(item.productId, item.qty - 1)}
                    >
                      −
                    </button>
                    <span className="qty-value">{item.qty}</span>
                    <button
                      type="button"
                      className="qty-btn"
                      onClick={() => updateQty(item.productId, item.qty + 1)}
                    >
                      +
                    </button>
                    <button
                      type="button"
                      className="btn btn-ghost btn-sm btn-danger"
                      onClick={() => removeItem(item.productId)}
                    >
                      ✕
                    </button>
                  </div>
                  <div className="cart-item-subtotal">
                    Q {(item.price * item.qty).toFixed(2)}
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>

        {cart && cart.items.length > 0 && (
          <div className="cart-drawer-footer">
            <div className="cart-subtotal">
              <span>Subtotal</span>
              <strong>Q {subtotal.toFixed(2)}</strong>
            </div>
            <button type="button" className="btn btn-primary btn-full" onClick={handleCheckout}>
              Confirmar pedido
            </button>
            <button type="button" className="btn btn-ghost btn-sm btn-full" onClick={handleClear}>
              Vaciar carrito
            </button>
          </div>
        )}
      </div>
    </>
  )
}
